/**
 * Formatting helpers used across the UI. Never mutate their inputs.
 */

/** Duration in minutes → "4h" / "1d 4h" / "12m" / "—" */
export function formatMinutes(mins) {
  if (mins === null || mins === undefined) return "—";
  if (typeof mins !== "number") return String(mins);
  if (mins === 0) return "0m";
  const days = Math.floor(mins / 1440);
  const hours = Math.floor((mins % 1440) / 60);
  const minutes = mins % 60;
  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);
  return parts.join(" ");
}

/** ISO date → "15 Jun 2025" (locale-agnostic, no time). */
export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.valueOf())) return String(iso);
  return d.toLocaleDateString(undefined, {
    day: "2-digit", month: "short", year: "numeric",
  });
}

/** ISO datetime → "15 Jun 2025, 14:32" */
export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.valueOf())) return String(iso);
  return d.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

/** Percentage (0-100 float) → "80%" */
export function formatPct(v) {
  if (v === null || v === undefined) return "—";
  if (typeof v !== "number") return String(v);
  return `${Number.isInteger(v) ? v : v.toFixed(1)}%`;
}

/** Short-form hash: first 8 + ellipsis. Full hash on hover / copy. */
export function shortHash(h) {
  if (!h) return "—";
  return `${h.slice(0, 8)}…`;
}

/** Bounded number label with tooltip fallback. */
export function safeNum(v) {
  if (v === null || v === undefined) return "—";
  return String(v);
}
